import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=9701bf4e"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"
import style0 from "./BaseCalendar.vue?vue&type=style&index=0&id=9701bf4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports